goog.provide('el8.apphome.docMgr.InboxFeed');

goog.require('el8.apphome.docMgr.renderer');
goog.require('el8.apphome.docMgr.FileFeed');

goog.require('el8.uiwidget.CollapsibleFeed');
goog.require('el8.uiwidget.FileUploader');
goog.require('el8.template.render.docMgr.organizer');
goog.require('el8.service.urls');
goog.require('el8.service.intervals');
goog.require('el8.appservice.notifier');
goog.require('el8.uiwidget.Hover');
goog.require('el8.apphome.docMgr.util');
goog.require('el8.util.dom');
goog.require('el8.util.consts');

el8.apphome.docMgr.InboxFeed = function(spec) {

    this._PAGE_SIZE = 7;
    this._SORTER_WIDTH = 250;

    this._inboxId = spec.inboxId;
    this._sorter = spec.sorter;

    this._dialogContainer = spec.dialogContainer;
    this._organizerContainer = spec.organizerContainer;

    this._fileFeeds = {};
    this._hoverWidgets = {};

    this._loadFileFn = spec.loadFileFn;
    this._removeFileFn = spec.removeFileFn;

    this._contentClass = 'filegroup-content';
    this._fileGroupsInProgress = {};

    this._showDeleted = spec.showDeleted || false;

    var that = this;
    $.extend(spec, {
        name: 'docMgr-'+that._inboxId,
        urlIndex: el8.service.urls.get('unfiledDocumentsFeedIndex', [that._inboxId]),
        rendererFn: function(_item) {
            var mClass = _item.getModelClass();
            switch(mClass) {
                case 'IncomingFileGroup':
                    return function(item, feedItemId) {
                        var obj = item.asSoyMap();
                        obj['feedItemId'] = feedItemId;
                        obj['hasImages'] = item.hasImages();
                        obj['showDeleted'] = that._showDeleted;
                        return el8.template.render.docMgr.organizer.incomingFileGroup(obj);
                    };
            };
            return null;
        },
        emptyTemplateFn: function() {return el8.template.render.docMgr.organizer.emptyInboxHeader({'showDeleted':that._showDeleted})},
        collapseEltClass: this._contentClass,
        contentWrapperClass: 'overlayFeedItem',
        fetchFn: function(arg, force, async) {
            var returnSingle = false;
            if (!(arg instanceof Array)) {
                returnSingle = true;
                arg = [arg];
            }
            var idList = arg.map(function(a) { return a['id']; });
            var result = [];
            idList.map(function(id) {
                result.push(el8.practicedata.incomingFileGroups.getById(id));
            });
            return returnSingle ? result[0] : result;
        },
        contentRendererFn: el8.apphome.docMgr.renderer.inboxItemContent,
        pageSize: that._PAGE_SIZE,
        skeletonFn: function(spec) {
            spec = spec || {};
            spec['inboxId'] = that._inboxId;
            return el8.template.render.docMgr.organizer.inboxContent(spec);
        },
        moreTrigger: '#docMgr-'+that._inboxId+'-feed-more-btn',
        clickTriggerMap: {
            '.header-trigger': function($target) {
                var item = el8.practicedata.incomingFileGroups.getById($target.attr('data-id')*1);
                that.toggleItem(item);
            }
        },
        addlExpandItemFn: function(item, divElt) {
            that._expandFn(item, divElt);
        },
        addlCollapseItemFn: function(item, divElt) {
            that._collapseFn(item, divElt);
        }
    });

    el8.uiwidget.CollapsibleFeed.prototype.constructor.call(this, spec);

    /* Need to over-ride reset method of the FeedRenderer to reset
     * fileFeeds dict */
    var super_rendererReset = this._feedRenderer.reset;
    this._feedRenderer.reset = function() {
        that._fileFeeds = {};
        that._hoverWidgets = {};
        super_rendererReset.call(that._feedRenderer);
    };

};
el8.apphome.docMgr.InboxFeed.inheritsFrom(el8.uiwidget.CollapsibleFeed);

/**
 * Extend standard Feed init() function to initialize helpful FileUploader
 * actions menu and also bind trigger
 */
el8.apphome.docMgr.InboxFeed.prototype.init = function() {

    el8.uiwidget.CollapsibleFeed.prototype.init.call(this);
    var that = this;

    this._fileUploader = new el8.uiwidget.FileUploader({
        container: this._container,
        queueArea: $('.upload-queue', this._container),
        droppableArea: this._container,
        droppableZoneClass: 'el8UploadDroppableOverlay',
        url: el8.service.urls.get('fileUpload', [this._inboxId]),
        onUploadMessage: 'Please do not delete files from your computer until they are listed as completed.',
        inputWidth: 111,
        inputHeight: 26,
        success: function(response, $queueEntry) {
            //successful network upload, meaning a pending/processing FileGroup
            $queueEntry.remove();
            var fileGroup = el8.practicedata.incomingFileGroups.create(response);
            that.updateFileGroupProcessing(fileGroup.getId());
        },
        isDisabled: that._showDeleted
    });
    $('.upload-file-container', this._container).html(
        this._fileUploader.getUploadFormContents()
    );

    this._container.on('click', 'a.upload-remove-trigger',  function(e) {
        var $elt = $(this);
        $elt.closest('.upload-file-entry').fadeOut(function() { $elt.remove(); });
    });
    this._actionsMenu = new el8.uiwidget.NewActionsMenu({
        container: this._container,
        anchorTop: this._feedRenderer.getListElt(),
        menuId: 'organizer-'+this._inboxId+'-actions-menu'
    });
    return this;
};

/**
 * Extend standard display and hide methods to manage objects specific
 * to this InboxFeed
 */
el8.apphome.docMgr.InboxFeed.prototype.display = function() {
    this.adjustSize();
    this._fileUploader.show();
    var that = this;
    el8.uiwidget.CollapsibleFeed.prototype.display.call(this, {
        /* Make sure 0th item is expanded */
        successCb: function() { that._feedRenderer.expandNthItem(0); }
    });
};
el8.apphome.docMgr.InboxFeed.prototype.hide = function() {
    this._fileUploader.hide();
    el8.uiwidget.CollapsibleFeed.prototype.hide.call(this);
};

/**
 * Extend standard reset, refresh, etc. methods
 */
el8.apphome.docMgr.InboxFeed.prototype.refreshItem = function(itemId, forceServer) {
    if (itemId instanceof el8_Entity) {
        itemId = itemId.getId();
    }
    delete this._fileFeeds[itemId];
    if (this._hoverWidgets[itemId]) {
        this._hoverWidgets[itemId].end();
    }
    /* Delete always to ensure it's undefined */
    delete this._hoverWidgets[itemId];
    el8.uiwidget.CollapsibleFeed.prototype.refreshItem.apply(this, arguments);
};
el8.apphome.docMgr.InboxFeed.prototype.update = function(opts) {
    // remove completed items from the upload queue on DocMgr "refresh"
    $('.upload-file-entry.completed-file', this._container).remove();
    el8.uiwidget.CollapsibleFeed.prototype.update.apply(this, arguments);
};
el8.apphome.docMgr.InboxFeed.prototype.refresh = function(opts) {
    // remove completed items from the upload queue on DocMgr "refresh"
    $('.upload-file-entry.completed-file', this._container).remove();
    var renderer = this._feedRenderer;
    el8.uiwidget.CollapsibleFeed.prototype.refresh.call(this, $.extend(opts, {
        /* Make sure 0th item is expanded */
        successCb: function() { renderer.expandNthItem(0); }
    }));
};
el8.apphome.docMgr.InboxFeed.prototype.syncShowDeleted = function() {
    this._fileUploader._isDisabled = this._showDeleted;
    this._fileUploader.resetUploadForm();
};

/**
 * New methods to do custom expand/collapse of feed items
 */
el8.apphome.docMgr.InboxFeed.prototype._expandFn = function(item, divElt) {

    $('.header-actions', divElt).show();
    $('.feed-spacer', divElt).show();
    var $content = $('.'+this._contentClass, divElt);

    var that = this;
    if (!this._fileFeeds[item.getId()]) {
        var feed = new el8.apphome.docMgr.FileFeed({
            container: $content,
            fileGroupContainer: divElt,
            sorter: this._sorter,
            fileGroupId: item.getId(),
            hasImages: item.hasImages(),
            inboxId: this._inboxId,
            dialogContainer: this._dialogContainer,
            inboxContainer: this._container,
            actionsMenu: this._actionsMenu,
            loadFileFn: this._loadFileFn,
            removeFileFn: function(itemId, fileGroupId) {
                that._removeFileFn(itemId);
                that._updateFileGroupTitle(fileGroupId);
                var fileGroup = el8.practicedata.incomingFileGroups.getById(fileGroupId);
                if (fileGroup && that._fileFeeds[fileGroup.getId()]) {
                    // TODO: is this necessary?
                    that._fileFeeds[fileGroup.getId()].loadIndex(fileGroup.getFileFeedIndex());
                }
            },
            destroyFn: function() {
                that.remove(item.getId(), el8.util.consts.DEFAULT_DURATION);
            }
        });
        feed.loadIndex(item.getFileFeedIndex());
        feed.display();
        this._fileFeeds[item.getId()] = feed;
        this._hoverWidgets[item.getId()] = (new el8.uiwidget.Hover({
            container: divElt,
            holder: $('.header-holder', divElt),
            hoverSection: $('.header-container', divElt),
            scrollContainer: this._container
        })).start();
    } else {
        this._fileFeeds[item.getId()].display();
        if (this._hoverWidgets[item.getId()]) { // just for safety; should be available here
            this._hoverWidgets[item.getId()].start();
        }
    }
};
el8.apphome.docMgr.InboxFeed.prototype._collapseFn = function(item, divElt) {
    $('.header-actions', divElt).hide();
    $('.header-holder', divElt).css('height', 'auto');
    $('.feed-spacer', divElt).hide();
    if (this._hoverWidgets[item.getId()]) {
        this._hoverWidgets[item.getId()].end({hover: false});
    }
    if (this._fileFeeds[item.getId()]) {
        this._fileFeeds[item.getId()].hide();
    }
};

/**
 * New methods defined specially for this feed to manage height/size
 */
el8.apphome.docMgr.InboxFeed.prototype.adjustSize = function() {
    this._container.height(
        this._organizerContainer.height()
        - $('.tabbed-nav', this._dialogContainer).outerHeight(true));
    this._container.outerWidth(this._organizerContainer.width());
};
el8.apphome.docMgr.InboxFeed.prototype._updateFileGroupTitle = function(itemId) {
    var $elt = this.getRenderItem(itemId);
    var item = el8.practicedata.incomingFileGroups.getById(itemId);
    $('.file-count', $elt).html(
        el8.template.render.docMgr.organizer.fileCount({fileCount: item.getFileCount()})
    );
};

/**
 * New methods, helpful public methods
 */
el8.apphome.docMgr.InboxFeed.prototype.getFileFeed = function(fileGroupId) {
    return this._fileFeeds[fileGroupId];
};
el8.apphome.docMgr.InboxFeed.prototype.pauseHover = function() {
    for (var id in this._hoverWidgets) {
        if (this._hoverWidgets.hasOwnProperty(id)) {
            this._hoverWidgets[id].pauseHover();
        }
    }
};

/**
 * EVENTS FOR UPLOADING FILES
 */
el8.apphome.docMgr.InboxFeed.prototype.updateFileGroupProcessing = function(fileGroupId,
        percentProgress) {
    /**
     * Call this when first replacing an 'uploading' group with one received by the server
     * or to update the progress of processing group
     */
    var fileGroup = el8.practicedata.incomingFileGroups.getById(fileGroupId, true);
    var soyMap = fileGroup.asSoyMap();

    if ($('.upload-file-entry[data-id="'+fileGroupId+'"]', this._container).length === 0) {
         // replacing an uploading group
        $('.upload-queue', this._container).append(
            $(el8.template.uiwidget.FileUploader.uploadFileEntry(soyMap)));
    } else {
         // updating progress
        if (percentProgress) { soyMap['percentProgress'] = percentProgress; }
        $('.upload-file-entry[data-id="'+fileGroupId+'"]', this._container).replaceWith(
            $(el8.template.uiwidget.FileUploader.uploadFileEntry(soyMap)));
    }
};
el8.apphome.docMgr.InboxFeed.prototype.updateFileGroupSuccess = function(fileGroupId) {
    /* Call this when the group has completed processing */
    var fileGroup = el8.practicedata.incomingFileGroups.getById(fileGroupId, true);
    $('.upload-file-entry[data-id="'+fileGroupId+'"]', this._container).replaceWith(
        $(el8.template.uiwidget.FileUploader.uploadFileEntry(fileGroup.asSoyMap())).addClass('completed-file')
    );
};
el8.apphome.docMgr.InboxFeed.prototype.updateFileGroupError = function(fileGroup) {
    /* Call this for an error either while uploading or processing the group */
    $('.upload-file-entry[data-id="'+fileGroup.getId()+'"]', this._container)
        .replaceWith($(el8.template.uiwidget.FileUploader.uploadFileEntry(fileGroup.asSoyMap())));
};
